import styled, { css } from 'styled-components';
import RatingComponent from '@prisjakt/ui-rating';

import { layout, media, styledUtils } from '@prisjakt/ui-base';

const ADVIZED_ORANGE = '#FD8825';

export const Wrapper = styled.li<{ grid: Boolean }>`
  order: 3;

  ${media.mediumDown`
    order: 1;
  `}

  ${media.mediumDown`
    order: 2;
  `}

  ${media.smallOnly`
    order: 1;
  `}

  ${props =>
    !props.grid &&
    css`
      min-width: 25%;
      flex: 1 1 25%;

      @media screen and (max-width: 820px) and (min-width: 520px) {
        min-width: 33%;
        flex: 1 1 33%;
        order: 2 !important;
      }

      @media screen and (max-width: 520px) {
        min-width: 50%;
        flex: 1 1 50%;
        order: 1 !important;
      }
    `}
`;

export const Inner = styled.a`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${layout.margins.wrapper.mobile.rem};
  @media (pointer: fine) {
    &:hover::after,
    &:focus::after {
      ${styledUtils.overlay()}
    }
  }
`;

export const Title = styled.h4`
  margin: 0;
`;

export const Subtitle = styled.div`
  color: ${p => p.theme.colors.base400};
`;

export const Products = styled.div`
  margin-top: ${layout.margins.wrapper.mobile.rem};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  margin-top: 4px;
`;

export const ProductName = styled.span`
  padding-left: ${layout.margins.wrapper.mobile.rem};
  text-align: left;
  font-size: 12px;
`;

export const Image = styled.div`
  flex: 0 0 30px;
  > img {
    max-height: 30px;
  }
`;

export const Avatar = styled.img`
  width: 35px;
  height: 35px;
  object-fit: cover;
  border-radius: 50%;
  box-shadow: 0 0 0 2px white, 0 0 0 3px ${ADVIZED_ORANGE};
  margin-right: ${layout.margins.wrapper.mobile.rem};
`;

export const Footer = styled.div`
  color: ${ADVIZED_ORANGE};
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-top: ${layout.margins.wrapper.mobile.rem};
`;

export const Description = styled.small`
  color: ${p => p.theme.colors.base500};
  margin-top: ${layout.margins.wrapper.mobile.rem};
`;

export const Rating = styled(RatingComponent)`
  margin-top: ${layout.margins.wrapper.mobile.rem};
`;
